export class MenuTagModel {
  id: number;
  table_name: string;
  table_record_id: number;
  name: string;

  constructor(id = 0,
              table_name = '',
              table_record_id = 0,
              name = '') {
    this.id = id;
    this.table_name = table_name;
    this.table_record_id = table_record_id;
    this.name = name;
  }
}
